const InfoModal = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end md:items-center z-[1001] backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-900 rounded-t-lg md:rounded-lg shadow-xl p-6 w-full max-w-md mx-auto relative transition-transform duration-300 transform md:animate-none animate-slideUp">
        <p className="text-lg font-semibold mb-4 dark:text-white">{message}</p>
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
            Okay
          </button>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
